import React from 'react';
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Alert from 'react-bootstrap/Alert'
import Logo from '../images/logo.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import { faAt } from '@fortawesome/free-solid-svg-icons/faAt'
import { faMapMarker } from '@fortawesome/free-solid-svg-icons/faMapMarker'
//nothing

const AboutUs = (props) => {
    return(
        <div className="home_container">     
            <div className="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center">
                <h1 className="display-4 font-weight-normal">About Us</h1>
            </div>

            <div className="container_fluid container col-lg-10 col-sm-12">
          
                
                <div className="after_navigation">
                    <div className="home_row_1 row p-0">
                        <Card style={{width:"100%",alignSelf:"auto", }}>
                            <Card.Header className="bg-primary text-center text-light" as="h3">Repair service at your doorstep @ ₹299 only! <span className="text-muted small">*</span></Card.Header>
                        </Card> 

                         <div className="special-card">
                            <Alert variant="Success" className="text-center">We donate 10% total profits to PM National relief fund ! (During Lockdown Period)</Alert>
                            <Card.Body className="text-dark font-weight-bold">                           
                                <Card.Title as="h4" >
                                    <strong>Contact Us: <br /></strong>
                                    <FontAwesomeIcon icon={faPhone} />94357-21000<br />
                                    <FontAwesomeIcon icon={faPhone} />98540-80080<br />
                                    <FontAwesomeIcon icon={faAt} />umangexport@hotmail.com
                                </Card.Title>
                                <hr />
                                <Card.Title as="h4" >
                                    <strong>Visit Us: <br /></strong>
                                    <FontAwesomeIcon icon={faMapMarker} />
                                     Umed Electronics <br />
                                    Ehshan commercial Complex <br />
                                    Ground floor , Sahida market lane ,
                                    Lakhtokia,  guwahati ,781001
                                    Assam<br />
                                    GST no 18AFSPC9795B1ZY
                                </Card.Title>
                                <hr />
                                <Card.Title as="h4" >
                                    <strong>Umed Electronics </strong>
                                    a leading gadgets store at Guwahati, Assam, established in 1998. We are working as Distributor, 
                                    wholesaler and  retailer of many leading brands since last 22 years. 
                                    We have 5 retail and wholesale outlets in Guwahati and sister concerns In entire northeast region of 
                                    mobile phone, mobile accessories,  CCTV products, security surveillance products, IT products, 
                                    Home Automation etc. We also provide service in same related field. 
                                </Card.Title>
                                <hr />
                                <Card.Title as="h4">                                    
                                    <strong>SERVICE:   </strong>
                                    With our strong service management system and integrated service model, most essential 
                                    component of an efficient service organisation of ensure timely resolutions. 
                                    We achieve highest level of customer satisfaction.
                                </Card.Title>
                                <hr />
                                <Card.Title as="h4">                                    
                                    <strong>TERMS AND CONDITIONS:   </strong>
                                    Mechanical service charge @ 299 applicable for every visit and if requirement 
                                    any spare parts for repairing then actual cost of spare parts applicable. 
                                    Service Charge of 18% is applicable on all items to cover expenses related to
                                    maintenance of this portal, expense of quality checking professionals against GST Bill.
                                </Card.Title>
                                <hr />
                                <Card.Title as="h4">                                    
                                    <strong>AUTOMATIC CANCELLATION OF ORDER:   </strong>
                                    By placing an order you confirm that your phone number is correct and valid.
                                    You also confirm that the area pin code you provided is correct. 
                                    Our caller will call you and once you pick up the call, only then your order will be accepted. 
                                    All orders with incorrect phone number and incorrect pin code will be cancelled automatically.
                                </Card.Title>
                                <div className="text-center fluid">
                                  <Button className="mx-auto align-center btn-lg" href="/CreateRequest" variant="success">Repair My Device</Button>
                                </div>
                            </Card.Body>    
                        </div>                                          
                       
                        
                    </div>
                </div>

            <div className="product-device product-device-2 box-shadow d-none d-lg-block"></div>
            <div className="product-device product-device-3 box-shadow d-none d-lg-block"></div>
            <div className="product-devicex product-device-4 box-shadow d-none d-lg-block"></div>

            </div>
        </div>
    )
}

export default AboutUs;